import { render, staticRenderFns } from "./UpgradeSeatPublic.vue?vue&type=template&id=e54159b2&scoped=true&"
import script from "./UpgradeSeatPublic.vue?vue&type=script&lang=js&"
export * from "./UpgradeSeatPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54159b2",
  null
  
)

export default component.exports